import React, { useState } from "react";
import { X } from "lucide-react";

const KEY = "soulumo_launch_banner_closed";

// Launch-week welcome. Closable; stays closed on this device.
export const LaunchBanner = ({ closable = true, flush }) => {
  const [closed, setClosed] = useState(() => closable && localStorage.getItem(KEY) === "1");
  if (closed) return null;
  return (
    <div className={`relative z-20 ${flush ? "" : "mt-14"} px-5 py-4 text-center`} data-testid="launch-banner"
      style={{ background: "linear-gradient(90deg, rgba(224,169,122,0.05), rgba(224,169,122,0.16), rgba(224,169,122,0.05))", borderBottom: "1px solid rgba(224,169,122,0.32)" }}>
      <p className="mx-auto max-w-3xl px-6" style={{ color: "#f5ecd9", fontFamily: "var(--font-ui)", fontSize: "clamp(1rem, 2.6vw, 1.15rem)", lineHeight: 1.45 }}>
        <span className="mr-2 not-" style={{ color: "#e0a97a" }} data-testid="launch-banner-title">Welcome to Soulumo.</span>
        <span className="" style={{ color: "rgba(245,236,217,0.82)" }}>
          We're just beginning, and we're so glad you're here. Create something that's truly yours, and begin changing the way you speak to yourself on a deeper level.
        </span>
      </p>
      {closable && (
        <button type="button" aria-label="Close" data-testid="launch-banner-close"
          onClick={() => { localStorage.setItem(KEY, "1"); setClosed(true); }}
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1.5 transition-colors hover:bg-white/10" style={{ color: "rgba(245,236,217,0.6)" }}>
          <X size={16} />
        </button>
      )}
    </div>
  );
};
